var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-card",
    { attrs: { flat: "" } },
    [
      _c(
        "v-card-text",
        { staticClass: "page--status_reports" },
        [
          _c("h2", { staticClass: "page-title" }, [
            _vm._v("Status Reports (Weekly)")
          ]),
          _vm._v(" "),
          _c("p", { staticClass: "text-xs-center" }, [
            _c("em", [_vm._v(_vm._s(_vm.lastChecked))])
          ]),
          _vm._v(" "),
          !!_vm.$roomService.rooms
            ? _c(
                "v-layout",
                { staticClass: "status_reports mt-4" },
                [
                  _c(
                    "v-flex",
                    [
                      _c(
                        "v-container",
                        {
                          staticClass: "top-container top-container--full",
                          attrs: { "grid-list-md": "" }
                        },
                        [
                          _c(
                            "v-layout",
                            {
                              attrs: {
                                row: "",
                                wrap: "",
                                "justify-space-around": ""
                              }
                            },
                            [
                              _c(
                                "v-flex",
                                {
                                  attrs: {
                                    lg4: "",
                                    md4: "",
                                    sm12: "",
                                    xs12: ""
                                  }
                                },
                                [
                                  _c("v-text-field", {
                                    attrs: {
                                      "append-icon": "search",
                                      label: "Rooms",
                                      "single-line": "",
                                      "hide-details": "",
                                      loading: _vm.$reportService.loading
                                    },
                                    model: {
                                      value: _vm.rawSearchTerms,
                                      callback: function($$v) {
                                        _vm.rawSearchTerms = $$v
                                      },
                                      expression: "rawSearchTerms"
                                    }
                                  })
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _vm.showDepartmentUnit
                                ? _c(
                                    "v-flex",
                                    {
                                      attrs: {
                                        lg4: "",
                                        md4: "",
                                        sm12: "",
                                        xs12: ""
                                      }
                                    },
                                    [
                                      _c("v-select", {
                                        staticClass: "select__room_org_units",
                                        attrs: {
                                          items: _vm.roomOrgUnits,
                                          "item-text": "label",
                                          "item-value": "value",
                                          label: "Department / Unit",
                                          loading: _vm.$reportService.loading,
                                          autocomplete: "",
                                          clearable: ""
                                        },
                                        model: {
                                          value: _vm.filter.roomOrgUnit,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.filter,
                                              "roomOrgUnit",
                                              $$v
                                            )
                                          },
                                          expression: "filter.roomOrgUnit"
                                        }
                                      })
                                    ],
                                    1
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              _c(
                                "v-flex",
                                {
                                  attrs: {
                                    lg4: "",
                                    md4: "",
                                    sm12: "",
                                    xs12: ""
                                  }
                                },
                                [
                                  _c("v-select", {
                                    staticClass: "select__room_owners",
                                    attrs: {
                                      items: _vm.roomOwners,
                                      "item-text": "label",
                                      "item-value": "value",
                                      label: "Owner",
                                      loading: _vm.$reportService.loading,
                                      autocomplete: "",
                                      clearable: ""
                                    },
                                    model: {
                                      value: _vm.filter.roomOwner,
                                      callback: function($$v) {
                                        _vm.$set(_vm.filter, "roomOwner", $$v)
                                      },
                                      expression: "filter.roomOwner"
                                    }
                                  })
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "v-flex",
                                {
                                  attrs: { lg6: "", md6: "", sm6: "", xs12: "" }
                                },
                                [
                                  _c("v-checkbox", {
                                    staticClass: "mx-auto",
                                    attrs: {
                                      label: "Only Show Overdue Rooms",
                                      color: "primary"
                                    },
                                    model: {
                                      value: _vm.filter.onlyOverdue,
                                      callback: function($$v) {
                                        _vm.$set(_vm.filter, "onlyOverdue", $$v)
                                      },
                                      expression: "filter.onlyOverdue"
                                    }
                                  })
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _vm.viewerIsRoomOwner
                                ? _c(
                                    "v-flex",
                                    {
                                      staticClass:
                                        "text-sm-right text-xs-center",
                                      attrs: {
                                        lg6: "",
                                        md6: "",
                                        sm6: "",
                                        xs12: ""
                                      }
                                    },
                                    [
                                      _c(
                                        "v-btn",
                                        {
                                          staticClass: "btn__my_rooms",
                                          attrs: { color: "primary" },
                                          on: {
                                            click: function($event) {
                                              _vm.filter.roomOwner = _vm.$auth.user().uid
                                            }
                                          }
                                        },
                                        [
                                          _c(
                                            "span",
                                            { staticClass: "btn__text" },
                                            [_vm._v("Show My Rooms")]
                                          )
                                        ]
                                      )
                                    ],
                                    1
                                  )
                                : _vm._e()
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c("v-data-table", {
                        attrs: {
                          search: _vm.filter.searchTerms,
                          headers: _vm.reportsTableHeaders,
                          items: _vm.reportsTableItems,
                          pagination: _vm.pagination,
                          "custom-filter": _vm.customSearchFilter,
                          loading: _vm.$reportService.loading,
                          "item-key": "room_id",
                          "must-sort": "",
                          "hide-actions": "",
                          "no-results-text":
                            "Sorry, either there are no results available that match the search criteria, or data is not currently available.",
                          "no-data-text":
                            "Sorry, either there are no results available that match the search criteria, or data is not currently available."
                        },
                        on: {
                          "update:pagination": function($event) {
                            _vm.pagination = $event
                          }
                        },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "headers",
                              fn: function(props) {
                                return [
                                  _c(
                                    "tr",
                                    { staticClass: "primary" },
                                    [
                                      _vm._l(props.headers, function(header) {
                                        return [
                                          !header.hide
                                            ? _c(
                                                "th",
                                                {
                                                  key: header.text,
                                                  class: [
                                                    header.sortable ||
                                                    header.align !== "left"
                                                      ? "px-1"
                                                      : "pr-1",
                                                    "white--text",
                                                    "text-xs-" +
                                                      (header.align
                                                        ? header.align
                                                        : "center"),
                                                    "column",
                                                    header.isWeekHeader
                                                      ? "column--room_status"
                                                      : "",
                                                    "column--" + header.value,
                                                    header.value ===
                                                    _vm.pagination.sortBy
                                                      ? "active"
                                                      : "",
                                                    header.sortable !== false
                                                      ? "sortable"
                                                      : "",
                                                    _vm.pagination.descending
                                                      ? "desc"
                                                      : "asc"
                                                  ],
                                                  attrs: {
                                                    role: "columnheader",
                                                    "aria-label": header.text,
                                                    "aria-sort": header.sortable
                                                      ? "sortable"
                                                      : ""
                                                  },
                                                  on: {
                                                    click: function($event) {
                                                      return _vm.changeSort(
                                                        header
                                                      )
                                                    }
                                                  }
                                                },
                                                [
                                                  header.sortable !== false
                                                    ? _c(
                                                        "v-icon",
                                                        {
                                                          attrs: {
                                                            color: "white"
                                                          }
                                                        },
                                                        [_vm._v("arrow_upward")]
                                                      )
                                                    : _vm._e(),
                                                  _vm._v(
                                                    "\n                      " +
                                                      _vm._s(header.text) +
                                                      "\n                    "
                                                  )
                                                ],
                                                1
                                              )
                                            : _vm._e()
                                        ]
                                      })
                                    ],
                                    2
                                  )
                                ]
                              }
                            },
                            {
                              key: "items",
                              fn: function(props) {
                                return [
                                  _c(
                                    "td",
                                    {
                                      staticClass:
                                        "text-xs-left column--room_report px-1 text-xs-center"
                                    },
                                    [
                                      _c(
                                        "v-layout",
                                        { attrs: { row: "" } },
                                        [
                                          _c(
                                            "v-flex",
                                            { attrs: { xs6: "" } },
                                            [
                                              _c(
                                                "v-btn",
                                                {
                                                  class: "ma-0",
                                                  attrs: {
                                                    color: "grey",
                                                    flat: "",
                                                    depressed: "",
                                                    small: "",
                                                    fab: "",
                                                    disabled:
                                                      _vm.roomReportDialog
                                                  },
                                                  on: {
                                                    click: function($event) {
                                                      return _vm.openRoomReport(
                                                        props.item.room_id
                                                      )
                                                    }
                                                  }
                                                },
                                                [
                                                  _c("v-icon", [
                                                    _vm._v("assignment")
                                                  ])
                                                ],
                                                1
                                              )
                                            ],
                                            1
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "v-flex",
                                            { attrs: { xs6: "" } },
                                            [
                                              _c(
                                                "v-btn",
                                                {
                                                  class: "ma-0",
                                                  attrs: {
                                                    color: "grey",
                                                    flat: "",
                                                    depressed: "",
                                                    small: "",
                                                    fab: ""
                                                  },
                                                  on: {
                                                    click: function($event) {
                                                      return _vm.startReport(
                                                        props.item.room_id
                                                      )
                                                    }
                                                  }
                                                },
                                                [
                                                  _c("v-icon", [_vm._v("edit")])
                                                ],
                                                1
                                              )
                                            ],
                                            1
                                          )
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "td",
                                    {
                                      staticClass:
                                        "text-xs-left column--room_label pr-1"
                                    },
                                    [
                                      _vm._v(
                                        "\n                " +
                                          _vm._s(props.item.label) +
                                          "\n              "
                                      )
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _vm.showDepartmentUnit
                                    ? _c(
                                        "td",
                                        {
                                          staticClass:
                                            "text-xs-left column--org_unit pr-1"
                                        },
                                        [
                                          !!props.item.org_unit.line1
                                            ? _c(
                                                "div",
                                                {
                                                  staticClass: "org_unit__line1"
                                                },
                                                [
                                                  _vm._v(
                                                    "\n                  " +
                                                      _vm._s(
                                                        props.item.org_unit
                                                          .line1
                                                      ) +
                                                      "\n                "
                                                  )
                                                ]
                                              )
                                            : _vm._e(),
                                          _vm._v(" "),
                                          !!props.item.org_unit.line2
                                            ? _c(
                                                "div",
                                                {
                                                  staticClass: "org_unit__line2"
                                                },
                                                [
                                                  _vm._v(
                                                    "\n                  " +
                                                      _vm._s(
                                                        props.item.org_unit
                                                          .line2
                                                      ) +
                                                      "\n                "
                                                  )
                                                ]
                                              )
                                            : _vm._e()
                                        ]
                                      )
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _c(
                                    "td",
                                    {
                                      staticClass:
                                        "text-xs-left column--campus pr-1"
                                    },
                                    [
                                      _vm._v(
                                        "\n                " +
                                          _vm._s(props.item.campus) +
                                          "\n              "
                                      )
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "td",
                                    {
                                      staticClass:
                                        "text-xs-left column--campus_region pr-1"
                                    },
                                    [
                                      _vm._v(
                                        "\n                " +
                                          _vm._s(props.item.campus_region) +
                                          "\n              "
                                      )
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "td",
                                    {
                                      class: [
                                        "text-xs-right",
                                        "column--room_minimum_frequency",
                                        "px-1",
                                        props.item.check_status_color_class
                                      ]
                                    },
                                    [
                                      !!props.item.support_level
                                        ? _c(
                                            "v-tooltip",
                                            { attrs: { right: "" } },
                                            [
                                              _c(
                                                "div",
                                                {
                                                  attrs: { slot: "activator" },
                                                  slot: "activator"
                                                },
                                                [
                                                  _vm._v(
                                                    _vm._s(
                                                      props.item
                                                        .minimum_frequency
                                                    ) + " Days"
                                                  )
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c("span", [
                                                _vm._v(
                                                  _vm._s(
                                                    props.item.support_level
                                                  )
                                                )
                                              ])
                                            ]
                                          )
                                        : _c("span", [
                                            _vm._v(
                                              _vm._s(
                                                props.item.minimum_frequency
                                              ) + " Days"
                                            )
                                          ])
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "td",
                                    {
                                      staticClass:
                                        "text-xs-left column--room_last_checked pr-1"
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm._f("date")(
                                            props.item.last_checked
                                          )
                                        )
                                      )
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _vm._l(_vm.weeks, function(week, index) {
                                    return [
                                      _c(
                                        "td",
                                        {
                                          key: index,
                                          staticClass:
                                            "text-xs-center px-1 column--room_status"
                                        },
                                        [
                                          _c(
                                            "v-icon",
                                            {
                                              attrs: {
                                                color: _vm.getStatusIcon(
                                                  props.item[
                                                    "room_status_" + week
                                                  ]
                                                ).color
                                              }
                                            },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.getStatusIcon(
                                                    props.item[
                                                      "room_status_" + week
                                                    ]
                                                  ).icon
                                                )
                                              )
                                            ]
                                          )
                                        ],
                                        1
                                      )
                                    ]
                                  })
                                ]
                              }
                            }
                          ],
                          null,
                          false,
                          45372355
                        )
                      }),
                      _vm._v(" "),
                      _c(
                        "v-dialog",
                        {
                          attrs: {
                            persistent: "",
                            scrollable: "",
                            "max-width": "90%",
                            "content-class": "dialog--room_status_reports"
                          },
                          model: {
                            value: _vm.roomReportDialog,
                            callback: function($$v) {
                              _vm.roomReportDialog = $$v
                            },
                            expression: "roomReportDialog"
                          }
                        },
                        [
                          _c(
                            "v-card",
                            [
                              _c(
                                "v-toolbar",
                                { attrs: { dark: "", color: "primary" } },
                                [
                                  _c("v-toolbar-title", [
                                    _vm._v(_vm._s(_vm.roomReportLabel))
                                  ]),
                                  _vm._v(" "),
                                  _c("v-spacer"),
                                  _vm._v(" "),
                                  _c(
                                    "v-btn",
                                    {
                                      attrs: { icon: "", dark: "" },
                                      nativeOn: {
                                        click: function($event) {
                                          return _vm.closeRoomReport()
                                        }
                                      }
                                    },
                                    [_c("v-icon", [_vm._v("close")])],
                                    1
                                  )
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c("v-data-table", {
                                attrs: {
                                  headers: _vm.roomReportTableHeaders,
                                  items: _vm.roomReportTableItems,
                                  loading: _vm.$reportService.loading,
                                  "item-key": "report_id",
                                  "hide-actions": "",
                                  "no-results-text":
                                    "No reports are available for this room.",
                                  "no-data-text":
                                    "No reports are available for this room."
                                },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "items",
                                      fn: function(props) {
                                        return [
                                          _c(
                                            "td",
                                            {
                                              staticClass:
                                                "text-xs-center column--room_status"
                                            },
                                            [
                                              _c(
                                                "v-icon",
                                                {
                                                  attrs: {
                                                    color: _vm.getStatusIcon(
                                                      props.item.room_status
                                                    ).color
                                                  }
                                                },
                                                [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.getStatusIcon(
                                                        props.item.room_status
                                                      ).icon
                                                    )
                                                  )
                                                ]
                                              )
                                            ],
                                            1
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "td",
                                            {
                                              staticClass:
                                                "text-xs-left column--date"
                                            },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm._f("date")(
                                                    props.item.timestamp
                                                  )
                                                )
                                              )
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "td",
                                            {
                                              staticClass:
                                                "text-xs-left column--notes"
                                            },
                                            [
                                              _c(
                                                "ul",
                                                {
                                                  staticClass:
                                                    "feature_bullet_list"
                                                },
                                                [
                                                  _vm._l(
                                                    props.item.inventory,
                                                    function(feature, index) {
                                                      return [
                                                        _c(
                                                          "li",
                                                          {
                                                            key: index,
                                                            class:
                                                              "feature_bullet_list_item feature_bullet_list_item--" +
                                                              _vm.getStatusIcon(
                                                                props.item[
                                                                  feature
                                                                    .featureId
                                                                ]
                                                              ).color
                                                          },
                                                          [
                                                            _c(
                                                              "strong",
                                                              {
                                                                staticClass:
                                                                  "feature_bullet__name"
                                                              },
                                                              [
                                                                _vm._v(
                                                                  "\n                            " +
                                                                    _vm._s(
                                                                      feature.featureName
                                                                    ) +
                                                                    "\n                          "
                                                                )
                                                              ]
                                                            ),
                                                            _vm._v(" "),
                                                            props.item[
                                                              feature.featureId +
                                                                "_issue_description"
                                                            ]
                                                              ? _c(
                                                                  "em",
                                                                  {
                                                                    staticClass:
                                                                      "feature_bullet__notes"
                                                                  },
                                                                  [
                                                                    _vm._v(
                                                                      "\n                            " +
                                                                        _vm._s(
                                                                          props
                                                                            .item[
                                                                            feature.featureId +
                                                                              "_issue_description"
                                                                          ]
                                                                        ) +
                                                                        "\n                          "
                                                                    )
                                                                  ]
                                                                )
                                                              : _vm._e()
                                                          ]
                                                        )
                                                      ]
                                                    }
                                                  )
                                                ],
                                                2
                                              )
                                            ]
                                          )
                                        ]
                                      }
                                    }
                                  ],
                                  null,
                                  false,
                                  1764027880
                                )
                              })
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            : _vm._e()
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-43c62aed", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-43c62aed","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/StatusReports.vue
// module id = Nw4Q
// module chunks = 1